<div class="card-content register-verify-contact-content">
  <!--title 區域-->
  <h1 class="card-title">{{ 'register-verify-contact.title' | translate }}</h1>

  <!--  form input 區域-->
  <form [formGroup]="verifyForm" (ngSubmit)="onSubmit()" class="register-verify-contact-form">
    <div class="input-block">
      <label class="input-title input-text-required" for="phone">{{
        'register-verify-contact.phone' | translate
        }}</label>
      <div class="input-group input-btn-right">
        <input id="phone" type="text" maxlength="10" formControlName="phone"
          [attr.disabled]="dontHavePhone ? true : null" [placeholder]="
            'register-verify-contact.phone-placeholder' | translate
          " [ngClass]="{
            'input-error': showPhoneError && verifyForm.get('phone')?.invalid,
          }" />
        @if (!isPhoneValid) {
        <!--btn:手機驗證碼-->
        <button [disabled]="dontHavePhone || otpCooldown > 0 || phoneOtpProcessing" mat-button type="button"
          (click)="sendPhoneOtp()" class="btn-text-primary input-otp-btn">
          {{ otpCooldown > 0 ? ('請稍後 ' + '(' + otpCooldown + 's' +')') : ('otp-dialog.send-otp' | translate) }}
        </button>
        } @else {
        <!--btn:手機驗證碼/驗證成功-->
        <div class="verify-success input-otp-btn">
          {{ 'register-verify-contact.verify-completed' | translate }}
          <img width="24" height="24" ngSrc="/assets/img/i-success-fill-green.svg" alt="" />
        </div>
        }
      </div>

      @if (showPhoneError && verifyForm.get('phone')?.invalid) {
      <span class="input-error-msg">{{ getPhoneErrorMessage() }}</span>
      }
      @if (!isPhoneValid && !dontHavePhone) {}
      <!-- 2026-08 必填手機需求 隱藏toggle -->
      <!--toggle:是否有手機-->
      <!-- <mat-slide-toggle
        [checked]="dontHavePhone"
        (change)="toggleDontHavePhone($event)"
      >
        <span class="register-verify-text">{{
          'register-verify-contact.dont-have-phone' | translate
        }}</span>
      </mat-slide-toggle> -->
      <!-- <div class="input-warn-msg">
        <img width="16" height="16" ngSrc="/assets/img/i-warn-outline.svg" alt="" />
        @if (dontHavePhone) {
        <span>{{
          'register-verify-contact.dont-have-phone-hint' | translate
          }}</span>
        } @else {
        <span>{{
          'register-verify-contact.phone-security-hint' | translate
          }}</span>
        }
      </div> -->
    </div>
    <div class="input-block">
      <label class="input-title input-text-required" for="email">{{
        'register-verify-contact.email' | translate
        }}</label>
      <div class="input-group input-btn-right">
        <input id="email" type="text" formControlName="email" class="email-input-custom" [placeholder]="
            'register-verify-contact.email-placeholder' | translate
          " [ngClass]="{
            'input-error': showEmailError && verifyForm.get('email')?.invalid,
          }" />
        @if (!isEmailValid) {
        <!--btn:email驗證碼-->
        <button type="button" mat-button (click)="sendEmailOtp()" [disabled]="otpCooldown > 0 || emailOtpProcessing"
          class="btn-text-primary input-otp-btn">
          {{ otpCooldown > 0 ? ('請稍後 ' + '(' + otpCooldown + 's' +')') : ('otp-dialog.send-otp' | translate) }}
        </button>
        } @else {
        <!--btn:email驗證碼/驗證成功-->
        <div class="verify-success input-otp-btn">
          {{ 'register-verify-contact.verify-completed' | translate }}
          <img width="24" height="24" ngSrc="/assets/img/i-success-fill-green.svg" alt="" />
        </div>
        }
      </div>

      @if (showEmailError && verifyForm.get('email')?.invalid) {
      <span class="input-error-msg">{{ getEmailErrorMessage() }}</span>
      }
      @if (!isEmailValid) {}

      <!-- <div class="input-warn-msg">
        <img width="16" height="16" ngSrc="/assets/img/i-warn-outline.svg" alt="" />
        <span>{{
          'register-verify-contact.email-security-hint' | translate
          }}</span>
      </div> -->
    </div>

    <!--按鈕:註冊會員 btn-->
    <button mat-button type="submit" class="btn-fill-primary btn-size-l">
      {{
      isValidationPass
      ? ('register-verify-contact.register' | translate)
      : ('register-verify-contact.register' | translate)
      }}
    </button>
  </form>
</div>

<!-- 底部提示文字-->
<div class="register-notice-text">
  <p>手機號碼需可接收簡訊，信箱建議使用個人信箱，以免影響後續通知。</p>
  <p>若無法提供，請聯繫客服 02-412-8006</p>
</div>

<!--btn-test 測試按鈕-->
<!-- @if (devService.isDev()) {
  <div class="btn-test">
    <mat-button-toggle-group [(ngModel)]="phoneCondition">
      <mat-button-toggle [value]="-1">phone pass</mat-button-toggle>
      <mat-button-toggle [value]="1">{{
        'error.phone-error.not-valid' | translate
      }}</mat-button-toggle>
    </mat-button-toggle-group>
  </div> -->

<!--btn-test 測試按鈕-->
<!-- <div class="btn-test">
    <mat-button-toggle-group [(ngModel)]="emailCondition">
      <mat-button-toggle [value]="-1">email pass</mat-button-toggle>
      <mat-button-toggle [value]="1">{{
        'error.email-error.not-valid' | translate
      }}</mat-button-toggle>
      <mat-button-toggle [value]="2">{{
        'error.email-error.already-register' | translate
      }}</mat-button-toggle>
    </mat-button-toggle-group>
  </div>
} -->